import { render, staticRenderFns } from "./users-bond-register.page.vue?vue&type=template&id=abeee3c2"
import script from "./users-bond-register.page.vue?vue&type=script&lang=ts"
export * from "./users-bond-register.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports